<template>
  <AuthLayout>
    <form @submit.prevent="submit" class="flex flex-col w-full gap-4">
      <InputPrimary :placeholder="$t('login.email')" v-model="email" :icon="EmailIcon" class="text-[#497384]" />
      <InputPrimary placeholder="Nueva contraseña" v-model="password" :icon="PassIcon" type="password" />
      <InputPrimary placeholder="Confirmar contraseña" v-model="passwordConfirm" :icon="PassIcon" type="password" />
      <ButtonComponent type="submit" :title="loading ? 'Enviando...' : 'Restablecer contraseña'" class="bg-[#3E7C94]" :disabled="loading" />

      <!-- <p v-if="token" class="text-sm text-gray-500">Token recibido desde la URL.</p> -->
      <p class="error" v-if="error">{{ error }}</p>
      <p class="success" v-if="success">{{ success }}</p>
    </form>
  </AuthLayout>
</template>

<script setup>
import { ref } from 'vue'
import axios from 'axios'
import { useRoute } from 'vue-router'
import InputPrimary from '@/components/inputs/input-primary.vue'
import EmailIcon from "@/assets/svg/EmailIcon.vue"
import PassIcon from "@/assets/svg/PassIcon.vue"
import ButtonComponent from '@/components/button/button-component.vue'
import AuthLayout from '@/components/layout/AuthLayout.vue'

const route = useRoute()

const token = ref(route.query.token || '')
const email = ref(route.query.email || '')
const password = ref('')
const passwordConfirm = ref('')
const loading = ref(false)
const error = ref('')
const success = ref('')

async function submit() {
  error.value = ''
  if (!email.value || !password.value) {
    error.value = 'Email y contraseña son obligatorios.'
    return
  }
  if (password.value !== passwordConfirm.value) {
    error.value = 'Las contraseñas no coinciden.'
    return
  }

  loading.value = true
  let apiSuccess = false

  try {
    const payload = {
      token: token.value,
      email: email.value,
      password: password.value,
      password_confirmation: passwordConfirm.value,
    }

    await axios.post(`${import.meta.env.VITE_API_URL}/user/password/reset`, payload)
    apiSuccess = true
    success.value = 'Contraseña actualizada correctamente. Redirigiendo al login...'
    localStorage.removeItem('token')
  } catch (err) {
    error.value = err.response?.data?.message || 'Error al restablecer la contraseña.'
  } finally {
    loading.value = false
  }

  if (apiSuccess) {
    window.location.href = '/login'
  }
}
</script>

<style scoped>
.error { color:#b00020; margin-top:12px; }
.success { color:#007a3d; margin-top:12px; }
</style>
